import React from "react";
import { Icon, Modal } from "antd";
import styles from "./index.module.scss";

interface FinishedImageProps {
    url: string;
    onClose: () => void;
    onClick: () => void;
}

export default function FinishedImage({
    url,
    onClose,
    onClick
}: FinishedImageProps) {
    function handleClose() {
        Modal.confirm({ content: "确定要删除吗？", onOk: onClose });
    }

    return (
        <div className={styles.root}>
            <img className={styles.image} src={url} alt="" onClick={onClick} />

            <Icon
                type="close-circle"
                theme="filled"
                className={styles.close}
                onClick={handleClose}
            />
        </div>
    );
}
